import React from 'react';

const DeleteModal = ({
  showDeleteConfirm,
  handleConfirmedDelete,
  setShowDeleteConfirm,
  isDeleting,
  modalStyles,
  deleteReason,
  setDeleteReason
}) => {
  if (!showDeleteConfirm) return null;

  const pills = [
    { label: 'Incorrect document selected', value: 'Incorrect document selected' },
    { label: 'Other', value: 'Other' }
  ];

  const confirmDisabled = isDeleting;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.box}>
        <h3 style={modalStyles.modalTitle}>Are you sure you want to delete this?</h3>
        <div style={{ marginTop: 10, marginBottom: 16 }}>
          <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
            {pills.map((pill) => {
              const isActive = deleteReason === pill.value;
              return (
                <button
                  key={pill.value}
                  type="button"
                  onClick={() => setDeleteReason(pill.value)}
                  style={{
                    padding: '10px 16px',
                    borderRadius: 999,
                    border: isActive ? '1px solid rgba(212,165,116,0.9)' : '1px solid rgba(141,110,78,0.35)',
                    background: isActive ? 'linear-gradient(135deg, #ffe9d6 0%, #fbe2c8 100%)' : '#fffaf3',
                    color: '#3d2817',
                    cursor: 'pointer',
                    fontWeight: 700,
                    letterSpacing: 0.4,
                    boxShadow: isActive ? '0 6px 14px rgba(141,110,78,0.2)' : '0 2px 8px rgba(0,0,0,0.06)',
                    transition: 'all 0.2s ease'
                  }}
                >
                  {pill.label}
                </button>
              );
            })}
          </div>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>
            Reason
          </label>
          <textarea
            value={deleteReason}
            onChange={(e) => setDeleteReason(e.target.value)}
            placeholder="Enter reason"
            maxLength={255}
            rows={3}
            style={{
              width: '100%',
              padding: '14px',
              borderRadius: 10,
              border: '1px solid rgba(141,110,78,0.35)',
              fontSize: '0.98rem',
              background: '#fffaf3',
              color: '#3d2817',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6), 0 1px 3px rgba(0,0,0,0.05)',
              minHeight: 90,
              resize: 'vertical',
              lineHeight: 1.45
            }}
          />
        </div>
        <div style={modalStyles.modalActions}>
          {/* <button
            onClick={handleConfirmedDelete}
            style={modalStyles.confirmButton}
          >
            Yes
          </button> */}
          <button
            onClick={handleConfirmedDelete}
            style={{
              ...modalStyles.confirmButton,
              opacity: confirmDisabled ? 0.6 : 1,
              cursor: confirmDisabled ? 'not-allowed' : 'pointer'
            }}
            disabled={confirmDisabled}
          >
            {isDeleting ? 'Deleting...' : 'Yes'}
          </button>
          <button
            onClick={() => {
              setShowDeleteConfirm(false);
              setDeleteReason('');
            }}
            style={modalStyles.cancelButton}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
